export type HubDiscipline = "microbiology" | "pathology";

export interface HubDisciplineConfig {
  discipline: HubDiscipline;
  label: string;
  description: string;
  accent: string;
  softAccent: string;
}

const DISCIPLINE_CONFIG: Record<HubDiscipline, HubDisciplineConfig> = {
  microbiology: {
    discipline: "microbiology",
    label: "Microbiology",
    description:
      "Culture, organism, parasite, virus, molecular and immune diagnostics",
    accent: "#087f79",
    softAccent: "#dff4ef",
  },
  pathology: {
    discipline: "pathology",
    label: "Pathology",
    description:
      "Blood, chemistry, urine, cytology and histopathology diagnostics",
    accent: "#6d50a2",
    softAccent: "#eee9f8",
  },
};

export function parseHubDiscipline(
  value: string | undefined,
): HubDiscipline | null {
  return value === "microbiology" || value === "pathology" ? value : null;
}

export function getHubDisciplineConfig(
  discipline: HubDiscipline,
): HubDisciplineConfig {
  return DISCIPLINE_CONFIG[discipline];
}

const viteEnvironment = (
  import.meta as ImportMeta & { env?: ImportMetaEnv }
).env;

export const hubDiscipline = parseHubDiscipline(
  viteEnvironment?.VITE_HUB_DISCIPLINE,
);
